export const environment = {
  production: false,
  apiUrl: 'https://developers-api.keslr.com/api',
  oidcAuthorizeUrl: 'https://api.keslr.com/api/oidc/authorize',
  oidcClientId: 'developers-portal',
  oidcRedirectUri: 'https://developers.keslr.com/auth/callback',
};
